import { render, staticRenderFns } from "./WkDep.vue?vue&type=template&id=cd73d58c&scoped=true"
import script from "./WkDep.vue?vue&type=script&lang=js"
export * from "./WkDep.vue?vue&type=script&lang=js"
import style0 from "./WkDep.vue?vue&type=style&index=0&id=cd73d58c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd73d58c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd73d58c')) {
      api.createRecord('cd73d58c', component.options)
    } else {
      api.reload('cd73d58c', component.options)
    }
    module.hot.accept("./WkDep.vue?vue&type=template&id=cd73d58c&scoped=true", function () {
      api.rerender('cd73d58c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewCom/WkDepSelect/src/WkDep.vue"
export default component.exports